import type { PillTone } from '../components/ui/Pill';
import type { ProgramParticipant } from '../contracts';

export interface Person {
  type: 'member' | 'contact' | 'detached';
  id: string | null;
  name: string | null;
  email: string | null;
}

export interface HistoryEntry {
  from: string | null;
  to: string;
  at: string;
  by?: string | null;
  source?: string;
  note?: string | null;
}

export type Participant = ProgramParticipant;

export const PARTICIPANT_STATUSES = ['invited', 'applied', 'selected', 'active', 'completed', 'withdrawn', 'declined'];

export const PARTICIPANT_TONE: Record<string, PillTone> = {
  invited: 'planned',
  applied: 'planned',
  selected: 'running',
  active: 'active',
  completed: 'healthy',
  withdrawn: 'inactive',
  declined: 'inactive',
};

export const PAYMENT_KINDS: Record<string, string> = {
  stipend: 'Stipend',
  honorarium: 'Honorarium',
  gift_card: 'Gift card',
  reimbursement: 'Reimbursement',
  registration: 'Registration',
  prize: 'Prize',
};

export const PAYMENT_STATUSES = ['owed', 'requested', 'submitted', 'approved', 'paid', 'cleared', 'cancelled'];

export const PAYMENT_STATUS_LABEL: Record<string, string> = {
  owed: 'Owed',
  requested: 'Requested',
  submitted: 'Submitted to York',
  approved: 'Approved',
  paid: 'Paid',
  cleared: 'Cleared',
  cancelled: 'Cancelled',
};

export const PAYMENT_TONE: Record<string, PillTone> = {
  owed: 'failed',
  requested: 'planned',
  submitted: 'running',
  approved: 'running',
  paid: 'healthy',
  cleared: 'healthy',
  cancelled: 'inactive',
};

export const label = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).replace(/_/g, ' ');

export const money = (cents: number | null | undefined) =>
  cents === null || cents === undefined
    ? '—'
    : (cents / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' });

export function toCents(dollars: string): number | null {
  const s = dollars.replace(/[$,\s]/g, '');
  if (!s) return null;
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return NaN;
  return Math.round(Number(s) * 100);
}

export const personName = (p: Person) => p.name || p.email || (p.type === 'detached' ? 'Deleted member' : 'Unknown');

interface ApiError {
  response?: { data?: { error?: string } };
}

export const errorMessage = (err: unknown, fallback: string) => (err as ApiError)?.response?.data?.error ?? fallback;

export const inputClass =
  'border border-line-strong rounded-sm bg-white px-3 py-[10px] min-h-[44px] text-table text-ink w-full';
export const selectClass = 'border border-line bg-white px-2 py-[6px] text-small';
